import React from 'react';
export function OpeningHook() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <p className="text-2xl md:text-3xl font-heading text-charcoal leading-relaxed" data-id="element-110">
          ¿Alguna vez se ha detenido a pensar qué pasaría con sus fotos, sus
          cuentas bancarias o sus mensajes{' '}
          <em className="text-burgundy font-semibold" data-id="element-111">
            si mañana su familia no pudiera acceder a su teléfono?
          </em>
        </p>

        <div className="w-24 h-1 bg-gold mx-auto my-10" data-id="element-112"></div>

        <p className="text-xl text-charcoal-light" data-id="element-113">
          No es falta de amor,{' '}
          <strong className="text-burgundy" data-id="element-114">es falta de una llave.</strong>{' '}
          Vivimos en un mundo donde todo está "en la nube", pero si usted no
          deja el mapa correcto, sus recuerdos y su patrimonio podrían quedar
          bajo llave para siempre.
        </p>
      </div>
    </section>;
}